<template>
  <ColumnContent :title="title">
    <a
      v-for="town in context.towns"
      :key="town.translit"
      class="d-table text--text link-decoration-none mb-4"
      data-qa="town-link"
      :class="{
        'text-body-1': !town.is_main_town,
        'text-subtitle-1': town.is_main_town,
      }"
      :href="reverseFullL10N({ name: 'town', args: { town_translit: town.translit, language: urlLang } })"
    >
      {{ transDynamic(town, `name,${iso},${needTranslate}`) }}
    </a>
  </ColumnContent>
</template>

<script setup lang="ts">
import I18NextVue from 'i18next'
import transDynamic from 'djanjucks/filters/transDynamic'
import { useContextStore, useURLStore } from 'src/store'
import { ColumnContent } from 'src/layouts'
import { ContextStore } from 'src/components/pages/town/types'

// @ts-ignore
const { context, urlLang }: ContextStore = useContextStore()
const { reverseFullL10N } = useURLStore()
const { need_translate: needTranslate } = context
const { iso } = context.current_language
const { t } = I18NextVue
// @ts-ignore
const title = t('Города', { ns: iso })
</script>
